import dayjs from "dayjs";
import React from "react";

export default function QRInfoTable({ data, currentStockQty }) {
  const table = {
    header: [
      {
        id: 1,
        title: "LOT",
      },
      {
        id: 2,
        title: "QR번호",
      },
      {
        id: 3,
        title: "제조일자",
      },
      {
        id: 4,
        title: "유효일자",
      },
      {
        id: 5,
        title: "재고수량",
      },
      {
        id: 6,
        title: "현재 재고수량",
      },
    ],
  };
  return (
    <>
      <div className="w-full block whitespace-nowrap overflow-auto">
        <table className="w-full text-center text-black">
          <thead>
            <tr className="border border-[#dddddd]" key={0}>
              {table.header.map((val) => (
                <th
                  className="p-2 bg-[#f2f2f4] border border-[#dddddd]"
                  key={val.id}
                >
                  {val.title}
                </th>
              ))}
            </tr>
          </thead>

          <tbody>
            <tr>
              <td className="p-3 border border-[#dddddd]">
                {data?.productLotInfo.lotNo}
              </td>
              <td className="p-3 border border-[#dddddd]">{data?.qrNo}</td>
              <td className="p-3 border border-[#dddddd]">
                {dayjs(data?.manufacDate).format("YYYY-MM-DD")}
              </td>
              <td className="p-3 border border-[#dddddd]">
                {dayjs(data?.expireDate).format("YYYY-MM-DD")}
              </td>
              <td className="p-3 border border-[#dddddd]">{data?.qnt}</td>
              <td className="p-3 border border-[#dddddd] font-bold">
                {currentStockQty}
              </td>
            </tr>
          </tbody>
        </table>
      </div>
    </>
  );
}
